export const queryStringToObject = (query = "") => {
  const urlParams = new URLSearchParams(query);

  return Object.fromEntries(urlParams);
};
